// @flow strict
/* eslint-disable css-modules/no-undef-class */
import * as React from 'react';
/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['top', 'bottom', 'right', 'left'] }] */
import styles from './Arrow.css';

/** The size of the arrow in px. */
export const ArrowSize = 12;
/** The size of the small arrow in px. */
export const SmallArrowSize = 7;

/** The side of the container on which the arrow should be attached */
export type Side = 'top' | 'bottom' | 'right' | 'left';
/** The side of the container from which the arrow should be offset */
export type OffsetSide = Side | 'center';
/** The distance the arrow should be offset from the edge  */
export type PixelCount = number;

type Props = {|
  /** The side of the container on which the arrow should be attached ('top', 'bottom', 'right', 'left). */
  on: Side,

  /** The side of the container from which the arrow should be offset ('top', 'bottom', 'right', 'left) or 'center'. If
   * it is 'center' then the 'offset' prop will be ignored.
   */
  from: OffsetSide,

  /** The distance the arrow should be offset from the edge. Defaults to 0. */
  offset: PixelCount,

  /** If true, use a small arrow */
  small: boolean,

  /** If true, invert the color of the arrow */
  inverted: boolean,
|};

/**
 * Arrows are used to visually attach an overlay to a button or other portion of the page that relates to the
 * contents of the overlay in some way. The component is fully configurable to allow the arrow to point at any point
 * along any of its parents' edges.
 */
const Arrow = ({ on, from, offset, small, inverted }: Props) => {
  const offsetStyle =
    from === 'center'
      ? {
          [on === 'top' || on === 'bottom' ? 'left' : 'top']: '50%',
          transform: on === 'top' || on === 'bottom' ? 'translate(-50%)' : 'translateY(-50%)',
        }
      : {
          [from]: `${offset}px`,
        };

  const style = [
    styles.arrow,
    styles[on],
    small ? styles.small : null,
    inverted ? styles.inverted : null,
  ]
    .filter(className => className)
    .join(' ');

  return <div className={style} style={offsetStyle} />;
};

Arrow.defaultProps = {
  from: 'center',
  offset: 0,
  small: false,
  inverted: false,
};

export default Arrow;
